var map = {
	"./board-background.webp": 2650,
	"./brick.webp": 1210,
	"./city-blue.webp": 8057,
	"./city-red.webp": 3089,
	"./city-white.webp": 1599,
	"./city-yellow.webp": 7982,
	"./dice-1.webp": 235,
	"./dice-2.webp": 8683,
	"./dice-3.webp": 5352,
	"./dice-4.webp": 980,
	"./dice-5.webp": 5548,
	"./dice-6.webp": 7108,
	"./dock.webp": 9398,
	"./grain.webp": 131,
	"./lumber.webp": 5503,
	"./ore.webp": 1562,
	"./road-blue-front.webp": 9504,
	"./road-blue-side-2.webp": 7289,
	"./road-blue-side.webp": 1745,
	"./road-red-front.webp": 9464,
	"./road-red-side-2.webp": 3749,
	"./road-red-side.webp": 5854,
	"./road-white-front.webp": 4088,
	"./road-white-side-2.webp": 9990,
	"./road-white-side.webp": 972,
	"./road-yellow-front.webp": 4128,
	"./road-yellow-side-2.webp": 511,
	"./road-yellow-side.webp": 7272,
	"./settlement-blue.webp": 1503,
	"./settlement-red.webp": 1714,
	"./settlement-white.webp": 4850,
	"./settlement-yellow.webp": 3201,
	"./someone.webp": 8915,
	"./thief.webp": 4852,
	"./tile-brick.webp": 8582,
	"./tile-desert.webp": 9979,
	"./tile-grain.webp": 6650,
	"./tile-lumber.webp": 135,
	"./tile-ore.webp": 4045,
	"./tile-wool.webp": 8573,
	"./wool.webp": 2897
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7226;